<template>
  <section class="page-finishings-list-product">
    <!-- Default -->
    <div class="row-1">
      <h2 class="title m-right-16px" v-anim-reveal-text>
        {{ $t('pages.product.finishingsTitle') }}
      </h2>
    </div>
    <div
      class="page-finishings-list-product__list row-1 m-top-5"
      v-if="finishings.length"
    >
      <h3 class="text-uppercase text-s">
        {{ $t('pages.product.finishingsExternalTitle') }}
      </h3>
      <ul class="page-finishings-list-product-blocks m-top-32px">
        <li v-for="finishing in finishings" :key="finishing.id">
          <PagesFinishingsListBlock :finishing="finishing" />
        </li>
      </ul>
    </div>
    <!-- Internal -->
    <div
      class="page-finishings-list-product__list row-1 m-top-5"
      v-if="internalFinishings.length"
    >
      <h3 class="text-uppercase text-s">
        {{ $t('pages.product.finishingsInternalTitle') }}
      </h3>
      <ul class="page-finishings-list-product-blocks m-top-32px">
        <li v-for="finishing in internalFinishings" :key="finishing.id">
          <PagesFinishingsListBlock :finishing="finishing" />
        </li>
      </ul>
    </div>

    <!-- Wire -->
    <div
      class="page-finishings-list-product__list row-1 m-top-5"
      v-if="wireFinishings.length"
    >
      <h3 class="text-uppercase text-s">
        {{ $t('pages.product.finishingsWireTitle') }}
      </h3>
      <ul class="page-finishings-list-product-blocks m-top-32px">
        <li v-for="finishing in wireFinishings" :key="finishing.id">
          <PagesFinishingsListBlock :finishing="finishing" />
        </li>
      </ul>
    </div>

    <!-- Base -->
    <div
      class="page-finishings-list-product__list row-1 m-top-5"
      v-if="baseFinishings.length"
    >
      <h3 class="text-uppercase text-s">
        {{ $t('pages.product.finishingsBaseTitle') }}
      </h3>
      <ul class="page-finishings-list-product-blocks m-top-32px">
        <li v-for="finishing in baseFinishings" :key="finishing.id">
          <PagesFinishingsListBlock :finishing="finishing" />
        </li>
      </ul>
    </div>

    <!-- All link -->
    <div class="m-top-6 row-1">
      <WidgetLinkMainUnderline
        :link="{
          key: 'all-finishes',
          route: { name: 'finishes' },
        }"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'PagesFinishingsListProduct',
}
</script>

<script setup>
const props = defineProps({
  finishings: Object,
  internalFinishings: Object,
  wireFinishings: Object,
  baseFinishings: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
